// Mock data for Maître Diamma website
import cities from './cities.json';

export const siteInfo = {
  name: "Marabout Africain Retour Affectif Rapide Guadeloupe - Maître Diamma",
  shortName: "Maître Diamma • Marabout Africain Guadeloupe",
  seoTitle: "Maître Diamma - Marabout Africain Guadeloupe",
  title: "Grand Marabout Africain Sorcier Vaudou Haïtien - Retour Affectif Rapide",
  phone: "+33745449641",
  whatsapp: "+33745449641",
  phoneDisplay: "+33 7 45 44 96 41",
  address: "15 Rue Frébault, 97110 Pointe-à-Pitre, Guadeloupe"
};

export const services = [
  {
    id: 1,
    title: "Retour Affectif Rapide et Définitif",
    description: "Maître Diamma est reconnu dans toute la Guadeloupe comme le grand spécialiste du retour affectif. Ce puissant sorcier vaudou utilise des rituels ancestraux de magie blanche et de magie rouge pour récupérer l'être aimé en quelques jours seulement. Que votre ex soit parti avec quelqu'un d'autre, qu'il vous ignore complètement ou qu'il refuse de vous parler, les rituels de retour affectif de Maître Diamma ramènent l'amour perdu. Plus de 15 ans d'expérience, 280 clients satisfaits. Résultats visibles annoncés sous 3 à 7 jours. Consultation discrète et efficace.",
    icon: "Heart",
    keywords: "retour affectif guadeloupe, récupérer son ex, rituel amour"
  },
  {
    id: 2,
    title: "Sorcier Vaudou - Rituels Puissants",
    description: "Maître Diamma est un authentique sorcier vaudou héritier d'une longue lignée de marabouts africains. Initié aux mystères ancestraux du vaudou béninois et haïtien, ce grand sorcier maîtrise parfaitement les rituels vaudou les plus puissants. Envoûtement d'amour, rituels de chance, protection contre les ennemis, ouverture des chemins bloqués, travaux occultes pour le succès professionnel et financier. Les pouvoirs de sorcellerie vaudou de Maître Diamma sont reconnus dans toute la Caraïbe. Interventions rapides et résultats garantis par ce grand sorcier vaudou de Guadeloupe.",
    icon: "Flame",
    keywords: "sorcier vaudou, vaudou guadeloupe, rituel vaudou puissant"
  },
  {
    id: 3,
    title: "Rituels de Magie Blanche",
    description: "Le marabout Maître Diamma, grand maître de la magie blanche, réalise des rituels de haute magie pour transformer positivement votre vie. Rituel d'amour pour attirer l'âme sœur, rituel de chance aux jeux et loteries, rituel de prospérité financière, rituel de protection spirituelle contre les énergies négatives, rituel de réussite aux examens et concours, rituel de fertilité et de grossesse. La magie blanche de Maître Diamma agit en harmonie avec les forces bénéfiques de l'univers pour exaucer vos vœux les plus chers. Solutions authentiques, éthiques et puissantes garanties par ce grand marabout de Guadeloupe.",
    icon: "Sparkles",
    keywords: "magie blanche, rituel amour, protection spirituelle"
  },
  {
    id: 4,
    title: "Rituels de Magie Rouge",
    description: "Spécialiste incontesté de la magie rouge en Guadeloupe, Maître Diamma pratique les rituels les plus efficaces pour raviver la passion amoureuse, consolider les liens du couple, attirer un amour impossible, provoquer le coup de foudre, rendre amoureux follement, faire revenir l'être aimé rapidement. La magie rouge du sorcier vaudou Maître Diamma agit directement sur les sentiments et les émotions pour créer une attraction irrésistible. Que vous soyez en couple ou célibataire, ces rituels de magie rouge transformeront radicalement votre vie sentimentale. Résultats puissants et durables garantis.",
    icon: "Heart",
    keywords: "magie rouge, passion amoureuse, rituel couple"
  },
  {
    id: 5,
    title: "Rituels de Magie Noire",
    description: "Pour les situations les plus complexes et désespérées, Maître Diamma maîtrise les rituels de magie noire les plus puissants. Ce grand sorcier vaudou intervient avec discrétion absolue pour séparer un couple, éloigner un rival, se venger d'ennemis, punir l'infidélité, protéger contre la sorcellerie, contrer les mauvais sorts. La magie noire de Maître Diamma agit rapidement et efficacement là où toutes les autres solutions ont échoué. Travaux occultes réservés aux cas graves nécessitant une intervention forte. Confidentialité totale et résultats garantis par ce grand marabout sorcier vaudou de Guadeloupe.",
    icon: "Moon",
    keywords: "magie noire guadeloupe, sorcier vaudou, rituel puissant"
  },
  {
    id: 6,
    title: "Désenvoutement et Protection Spirituelle",
    description: "Vous êtes victime d'envoûtement, de mauvais œil, de malédiction, de sorcellerie ou d'attaques occultes ? Le médium marabout Maître Diamma détecte immédiatement tous types de sorts et travaux négatifs. Grâce à ses puissants pouvoirs de sorcier vaudou, il réalise des rituels de désenvoutement complets pour vous libérer définitivement. Désenvoutement amoureux, désenvoutement professionnel, purification spirituelle, nettoyage énergétique, protection contre le retour des sorts, blindage contre la sorcellerie. Après le désenvoutement, Maître Diamma installe une protection spirituelle permanente. Libération totale et protection garanties.",
    icon: "Shield",
    keywords: "désenvoutement, enlever malédiction, protection"
  },
  {
    id: 7,
    title: "Voyance et Consultation de Médium",
    description: "Maître Diamma est un voyant médium de grande renommée en Guadeloupe. Doté de puissants dons de clairvoyance hérités de ses ancêtres, ce médium marabout voit votre passé, présent et futur avec une précision stupéfiante. Consultation de voyance pour connaître votre avenir amoureux, professionnel et financier. Voyance par téléphone, voyance par WhatsApp ou consultation en personne. Le médium Maître Diamma répond à toutes vos questions avec sincérité et bienveillance. Guidance spirituelle pour prendre les bonnes décisions, prédictions amoureuses, prévisions professionnelles, conseils de vie. Un vrai voyant sérieux et reconnu.",
    icon: "Eye",
    keywords: "voyant guadeloupe, médium sérieux, consultation voyance"
  },
  {
    id: 8,
    title: "Travaux Occultes et Guérison Spirituelle",
    description: "Grand guérisseur spirituel et marabout traditionnel, Maître Diamma réalise tous types de travaux occultes et de guérison mystique. Guérison des maladies spirituelles et psychosomatiques, soin énergétique, déblocage de situation bloquée, ouverture des chemins de la chance, rituel de réconciliation familiale, travaux pour la réussite commerciale, pacte spirituel, évocation des esprits, communication avec les ancêtres, bénédiction de maison ou commerce, consécration d'objets, talismans et gris-gris de protection. Le marabout guérisseur Maître Diamma utilise des méthodes ancestrales africaines transmises de génération en génération. Solutions spirituelles complètes pour tous vos problèmes de vie.",
    icon: "Sparkles",
    keywords: "guérisseur spirituel, travaux occultes, marabout africain"
  }
];

// Import testimonials from separate file
export { testimonials } from './testimonials';

export const guadeloupeCity = cities;

// Mots-clés SEO basés sur recherches réelles Guadeloupe 2025
export const topKeywords = [
  "marabout africain guadeloupe",
  "retour affectif rapide guadeloupe", 
  "retour amoureux rapide efficace",
  "marabout sérieux retour ex guadeloupe",
  "sorcier vaudou haïtien guadeloupe",
  "voyant médium guadeloupe",
  "marabout retour aimé",
  "rituel amour guadeloupe",
  "désenvoûtement guadeloupe",
  "marabout africain retour affectif",
  "guérisseur spirituel guadeloupe",
  "voyance sérieuse guadeloupe",
  "marabout pointe-à-pitre",
  "retour affectif immédiat",
  "magie blanche retour amour",
  "sorcellerie vaudou guadeloupe",
  "initiation vaudou",
  "rituel vaudou puissant",
  "marabout traditionaliste africain",
  "voyant africain guadeloupe"
];

export const keywords = [
  "marabout guadeloupe", "voyant guadeloupe", "retour affectif guadeloupe",
  "magie blanche guadeloupe", "magie noire guadeloupe", "magie rouge guadeloupe",
  "désenvoutement guadeloupe", "sorcier vaudou guadeloupe", "médium guadeloupe",
  "guérisseur guadeloupe", "rituel amour guadeloupe", "récupérer son ex guadeloupe",
  "grand marabout", "voyant sérieux", "retour de l'être aimé"
];
